/* SheffRack theme behaviour: mobile sticky bars */
(function () {
  var PRICE_RE = /£\s?\d[\d,]*(\.\d{2})?/;

  function initProductBar(bar) {
    var form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"][id^="product-form"]');
    var submit = form ? form.querySelector('[type="submit"], .product-form__submit') : null;
    var btn = bar.querySelector('[data-sr-add]');
    var priceEl = bar.querySelector('[data-sr-price]');
    var info = document.querySelector('.product__info-container') || document.body;

    if (btn) {
      btn.addEventListener('click', function () {
        if (submit && !submit.disabled) {
          submit.click();
        } else if (submit) {
          submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          info.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }

    // Mirror the price shown on the page (Option Calculator total, else theme price)
    function readPrice() {
      var found = null;
      var nodes = info.querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (bar.contains(n) || n.children.length || n.closest('.sr-vat')) continue;
        var t = (n.textContent || '').trim();
        if (t.length > 14) continue;
        var m = t.match(PRICE_RE);
        if (m && n.offsetParent !== null) found = m[0].replace(/\s/g, '');
      }
      if (found && priceEl) priceEl.textContent = found;
      if (found) showVat(found);
    }

    // Second price line: ex VAT if store prices include VAT, otherwise inc VAT
    var incl = bar.getAttribute('data-sr-incl') === 'true';
    var rate = parseFloat(bar.getAttribute('data-sr-rate')) || 20;
    function showVat(text) {
      var value = parseFloat(text.replace(/[£,\s]/g, ''));
      if (isNaN(value)) return;
      var other = incl ? value * 100 / (100 + rate) : value * (100 + rate) / 100;
      var label = incl ? bar.getAttribute('data-sr-ex') : bar.getAttribute('data-sr-inc');
      var out = other.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }) + ' ' + label;
      var targets = document.querySelectorAll('[data-sr-vat-live], .sr-vat--bar');
      for (var j = 0; j < targets.length; j++) { targets[j].textContent = out; targets[j].hidden = false; }
    }
    readPrice();
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(readPrice, 120); })
        .observe(info, { subtree: true, childList: true, characterData: true });
    }
    info.addEventListener('input', function () { setTimeout(readPrice, 250); });

    // Only show the bar when the real Add to cart button is off screen
    if (submit && 'IntersectionObserver' in window) {
      bar.hidden = true;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          bar.hidden = e.isIntersecting;
          document.body.classList.toggle('sr-has-bar', !e.isIntersecting);
        });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(submit);
    } else {
      document.body.classList.add('sr-has-bar');
    }
  }

  function init() {
    var bars = document.querySelectorAll('[data-sr-bar]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (bar.getAttribute('data-sr-bar') === 'product') {
        initProductBar(bar);
      } else {
        document.body.classList.add('sr-has-bar');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
